import Vue from "vue";

import { emitToastr } from "@/lib/Utils";
import Api from "@/lib/Api";

Vue.prototype.$toast = emitToastr;
Vue.prototype.$api = Api;
Vue.prototype.$vindi_statuses = [{ id: 'active', color: 'success', name: 'Ativo' }, { id: 'inactive', color: 'warning', name: 'Inativo' }, { id: 'canceled', color: 'error lighten-1', name: 'Cancelada' }];

Vue.prototype.$user_permissions = [
    { id: 'DEFAULT', name: "Website" },
    { id: 'SECRETARY_ASSISTANT', name: "Assistente de secretária" },
    { id: 'ARTICLE_ASSISTANT', name: "Assistente de artigos" },
    { id: 'CONVERSATION_ANALYSIS', name: "Análise de atendimentos" },
    { id: 'GEO_SEO_PRESENCE', name: "Presença GEO e SEO" }
];

Vue.prototype.$article_assistant_types = [
    { id: 'researcher', name: "Pesquisador" },
    { id: 'writer', name: "Escritor" },
    { id: 'reviewer', name: "Revisor" }
];
